import script from "./CombinedTargetCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinedTargetCard.vue?vue&type=script&setup=true&lang=ts"

export default script